import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "workflow-controls-wrapper" },
    [
      !_vm.isUnitManagerView
        ? _c(
            VTooltip,
            {
              attrs: { bottom: "", "content-class": "engine-tooltip" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "span",
                          _vm._g(_vm._b({}, "span", attrs, false), on),
                          [
                            _c(
                              VBtn,
                              {
                                class: [
                                  "refresh-button",
                                  "mr-2",
                                  `${
                                    _vm.hasUnsavedKpiResults &&
                                    !_vm.calculatingScenarioResults
                                      ? "unsaved-kpis"
                                      : ""
                                  }`,
                                ],
                                attrs: {
                                  depressed: "",
                                  loading: _vm.calculatingScenarioResults,
                                  disabled:
                                    !_vm.isEditable ||
                                    !_vm.engineCanRun ||
                                    _vm.calculatingScenarioElasticityResults,
                                  "data-dd-action-name":
                                    "Grid view recalculate all",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.recalculate()
                                  },
                                },
                              },
                              [_c("cog-play-icon")],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                203870653
              ),
            },
            [
              _vm._v(" "),
              _vm.engineCanRun &&
              !_vm.calculatingScenarioElasticityResults &&
              !_vm.hasUnsavedKpiResults
                ? [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("gridView.tooltips.strategicOptimiser"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(VDivider, {
                      staticClass: "my-2",
                      attrs: { dark: "" },
                    }),
                    _vm._v(" "),
                    _c("last-triggered-info", {
                      attrs: {
                        "last-triggered-info": _vm.get(
                          _vm.lastTriggeredInfo.strategic_engine_full_run,
                          _vm.scenario,
                          {}
                        ),
                        loading: _vm.isLastTriggeredLoading.strategic_engine,
                        source: "strategic_engine_full_run",
                        width: 200,
                      },
                    }),
                  ]
                : [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("gridView.tooltips.strategicOptimiser"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(VDivider, {
                      staticClass: "my-2",
                      attrs: { dark: "" },
                    }),
                    _vm._v(" "),
                    _vm.isString(_vm.engineButtonTooltipMsg)
                      ? _c("div", [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.engineButtonTooltipMsg) +
                              "\n      "
                          ),
                        ])
                      : _c(
                          "div",
                          _vm._l(
                            _vm.engineButtonTooltipMsg,
                            function (val, key) {
                              return _c(
                                "div",
                                {
                                  key: key,
                                  staticClass: "engine-blocked-tooltip-item",
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(key) + ":")]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(val))]),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                    _vm._v(" "),
                    _c(VDivider, {
                      staticClass: "my-2",
                      attrs: { dark: "" },
                    }),
                    _vm._v(" "),
                    _c("last-triggered-info", {
                      attrs: {
                        "last-triggered-info": _vm.get(
                          _vm.lastTriggeredInfo.strategic_engine_full_run,
                          _vm.scenario,
                          {}
                        ),
                        loading: _vm.isLastTriggeredLoading.strategic_engine,
                        source: "strategic_engine_full_run",
                        width: 200,
                      },
                    }),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isUnitManagerView
        ? _c(
            "feature-toggle",
            { attrs: { toggle: _vm.enablePriceOptimisation } },
            [
              _c(
                "feature-toggle",
                {
                  attrs: {
                    toggle: _vm.displayPriceOptimisationButtonOnlyForPriceList,
                    inverted: true,
                  },
                },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { bottom: "", "content-class": "engine-tooltip" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "span",
                                  _vm._g(_vm._b({}, "span", attrs, false), on),
                                  [
                                    _c(
                                      VBtn,
                                      {
                                        class: [
                                          "refresh-button",
                                          "cross-elasticity-button",
                                          "mr-2",
                                        ],
                                        attrs: {
                                          depressed: "",
                                          loading:
                                            _vm.calculatingScenarioElasticityResults,
                                          disabled: !_vm.canRunOptimisation,
                                          "data-dd-action-name":
                                            "Grid view cross-elasticity run",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.runCrossElasticityOptimisation()
                                          },
                                        },
                                      },
                                      [_c("circles-play-icon")],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2514242149
                      ),
                    },
                    [
                      _vm._v(" "),
                      _vm.canRunOptimisation
                        ? [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "gridView.tooltips.crossElasticityOptimiser"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(VDivider, {
                              staticClass: "my-2",
                              attrs: { dark: "" },
                            }),
                            _vm._v(" "),
                            _c("last-triggered-info", {
                              attrs: {
                                "last-triggered-info": _vm.get(
                                  _vm.lastTriggeredInfo.cross_elasticity_engine,
                                  _vm.scenario,
                                  {}
                                ),
                                loading:
                                  _vm.isLastTriggeredLoading
                                    .cross_elasticity_engine,
                                source: "cross_elasticity_engine",
                                "translation-time-key":
                                  "gridView.optimisationLastRunTime",
                                width: 200,
                              },
                            }),
                          ]
                        : [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "gridView.tooltips.crossElasticityOptimiser"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(VDivider, {
                              staticClass: "my-2",
                              attrs: { dark: "" },
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.crossElasticityButtonTooltipMsg)
                              ),
                            ]),
                            _vm._v(" "),
                            _c(VDivider, {
                              staticClass: "my-2",
                              attrs: { dark: "" },
                            }),
                            _vm._v(" "),
                            _c("last-triggered-info", {
                              attrs: {
                                "last-triggered-info": _vm.get(
                                  _vm.lastTriggeredInfo.cross_elasticity_engine,
                                  _vm.scenario,
                                  {}
                                ),
                                loading:
                                  _vm.isLastTriggeredLoading
                                    .cross_elasticity_engine,
                                source: "cross_elasticity_engine",
                                "translation-time-key":
                                  "gridView.optimisationLastRunTime",
                                width: 200,
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showToolStoreGroup && _vm.sortedStoreGroups.length
        ? _c(
            "div",
            { staticClass: "store-group-badges" },
            _vm._l(_vm.sortedStoreGroups, function (sg) {
              return _c(
                VTooltip,
                {
                  key: sg.toolStoreGroupKey,
                  attrs: {
                    bottom: "",
                    disabled: !_vm.storeGroupBadgeClass(sg.toolStoreGroupKey),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "span",
                              _vm._g(
                                _vm._b(
                                  {
                                    class: [
                                      "store-group-badge",
                                      _vm.storeGroupBadgeClass(
                                        sg.toolStoreGroupKey
                                      ),
                                    ],
                                  },
                                  "span",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(sg.toolStoreGroupDescription) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.storeGroupBadgeTooltip(sg.toolStoreGroupKey)) +
                      "\n    "
                  ),
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isUnitManagerView
        ? _c(VDivider, { staticClass: "mx-3", attrs: { vertical: "" } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isUnitManagerView
        ? _c(
            "feature-toggle",
            { attrs: { toggle: _vm.allowBulkPriceOverrides } },
            [
              _c(
                VTooltip,
                {
                  attrs: { bottom: "", disabled: !_vm.isBulkActionsDisabled },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on: tooltipOn, attrs: tooltipAttrs }) {
                          return [
                            _c(
                              VMenu,
                              {
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({
                                        on: menuOn,
                                        attrs: menuAttrs,
                                      }) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              _vm._b(
                                                {},
                                                "span",
                                                tooltipAttrs,
                                                false
                                              ),
                                              tooltipOn
                                            ),
                                            [
                                              _c(
                                                VBtn,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "bulk-actions-button pa-0 mr-2",
                                                      attrs: {
                                                        outlined: "",
                                                        small: "",
                                                        disabled:
                                                          _vm.isBulkActionsDisabled,
                                                        loading:
                                                          _vm.bulkSelectionState
                                                            .isLoading,
                                                      },
                                                    },
                                                    "v-btn",
                                                    menuAttrs,
                                                    false
                                                  ),
                                                  menuOn
                                                ),
                                                [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: { small: "" },
                                                    },
                                                    [_vm._v("mdi-menu-down")]
                                                  ),
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "gridView.bulkActions.label"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                  _vm.bulkSelectionState
                                                    .selectedCount > 0
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "ml-1" },
                                                        [
                                                          _vm._v(
                                                            "\n                  (" +
                                                              _vm._s(
                                                                _vm
                                                                  .bulkSelectionState
                                                                  .selectedCount
                                                              ) +
                                                              ")\n                "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  VList,
                                  { attrs: { dense: "" } },
                                  _vm._l(
                                    _vm.bulkPriceOverrideMenuItems,
                                    function (item) {
                                      return _c(
                                        VListItem,
                                        {
                                          key: item.action,
                                          on: {
                                            click: function ($event) {
                                              return _vm.onBulkPriceOverrideSelected(
                                                item.action
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(VListItemTitle, [
                                            _vm._v(
                                              _vm._s(_vm.$t(item.labelKey))
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3735583138
                  ),
                },
                [_vm._v("\n      " + _vm._s(_vm.bulkActionsTooltip) + "\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.readFromDatabricks
        ? _c(
            VTooltip,
            {
              attrs: { bottom: "", disabled: !_vm.hasUnsavedKpiResults },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "span",
                          _vm._g(_vm._b({}, "span", attrs, false), on),
                          [
                            _c(
                              VBtn,
                              {
                                class: [
                                  "save-button",
                                  "pa-0",
                                  `${
                                    _vm.hasUnsavedKpiResults
                                      ? "unsaved-kpis"
                                      : ""
                                  }`,
                                ],
                                attrs: {
                                  outlined: "",
                                  small: "",
                                  depressed: "",
                                  disabled: !_vm.hasUnsavedKpiResults,
                                  loading: _vm.savingKpiResults,
                                },
                                on: { click: _vm.onSaveKpiResultsToDatabricks },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("gridView.saveChanges")) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3258533559
              ),
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("gridView.tooltips.hasUnsavedKpiResults")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }